export const SET_WISHLIST = 'SET_WISHLIST';
export const SET_LOADING_WISHLIST = 'SET_LOADING_WISHLIST';
export const ADD_WISHLIST_ITEM = 'ADD_WISHLIST_ITEM';
export const DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM';